import script from "./ModalAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalAlert.vue?vue&type=script&setup=true&lang=js"

import "./ModalAlert.vue?vue&type=style&index=0&id=31060c4c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\unensedu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31060c4c"]])

export default __exports__